class PurefectAllergenDirectory extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.input = this.querySelector('[data-allergen-search]');
    this.clearButton = this.querySelector('[data-allergen-clear]');
    this.cards = Array.from(this.querySelectorAll('[data-allergen-product]'));
    this.filterButtons = Array.from(this.querySelectorAll('[data-allergen-filter]'));
    this.status = this.querySelector('[data-allergen-status]');
    this.emptyState = this.querySelector('[data-allergen-empty]');
    this.activeCategory = 'all';

    if (!this.input || !this.cards.length) return;

    this.input.addEventListener('input', () => this.render());
    this.input.addEventListener('search', () => this.render());
    this.clearButton?.addEventListener('click', () => this.clearSearch());

    this.filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeCategory = button.dataset.allergenFilter || 'all';
        this.filterButtons.forEach((candidate) => {
          const isActive = candidate === button;
          candidate.classList.toggle('is-active', isActive);
          candidate.setAttribute('aria-pressed', String(isActive));
        });
        this.render();
      });
    });

    this.applyProductContext();
    this.render();
  }

  normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  applyProductContext() {
    const parameters = new URLSearchParams(window.location.search);
    const productHandle = parameters.get('product');
    const query = parameters.get('q');

    if (productHandle) {
      const match = this.cards.find((card) => card.dataset.productHandle === productHandle);
      if (match) {
        this.input.value = match.dataset.productTitle || '';
        match.classList.add('is-targeted');
        match.querySelector('details')?.setAttribute('open', '');
      }
    } else if (query) {
      this.input.value = query;
    }
  }

  render() {
    const query = this.normalize(this.input.value);
    let visibleCount = 0;

    this.cards.forEach((card) => {
      const nameMatches = !query || this.normalize(card.dataset.productTitle).includes(query);
      const categoryMatches =
        this.activeCategory === 'all' || card.dataset.productCategory === this.activeCategory;
      const isVisible = nameMatches && categoryMatches;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (this.clearButton) this.clearButton.hidden = !this.input.value;
    if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;

    if (this.status) {
      const noun = visibleCount === 1 ? 'dish' : 'dishes';
      this.status.textContent = `Showing ${visibleCount} ${noun}`;
    }
  }

  clearSearch() {
    this.input.value = '';
    this.cards.forEach((card) => card.classList.remove('is-targeted'));

    const url = new URL(window.location.href);
    url.searchParams.delete('product');
    url.searchParams.delete('q');
    url.hash = '';
    window.history.replaceState({}, '', url);

    this.render();
    this.input.focus();
  }
}

if (!customElements.get('purefect-allergen-directory')) {
  customElements.define('purefect-allergen-directory', PurefectAllergenDirectory);
}
